// extracted by mini-css-extract-plugin
module.exports = {"denied__table":"index--denied__table--3wMBf"};